import { CollapsibleSection } from './CollapsibleSection'
import { DeletingSectionIndicator } from './DeletingSection'

export default CollapsibleSection
export {
  DeletingSectionIndicator
}
